// extracted by mini-css-extract-plugin
export default {"introductionsmall":"not-authenticated_introductionsmall__OVUL6","bullets":"not-authenticated_bullets__NK928"};